import * as echarts from "echarts";
export default {
  data() {
    return {
      barChart: null,
      myChart: null,
      myChart1: null,
      pieChat: null,
      barChart9: null,
      placeType1: {
        1: "生产基地/企业",
        2: "屠宰场",
        3: "农贸市场",
        4: "批发市场",
        5: "超市",
        6: "其他",
        7: '种养殖散户',
        8: '合作社',
        9: '养殖场'
      }
    };
  },
  methods: {
    getColorByName(name) {
      let colorList = [
        "#0990DD",
        "#2CD8DC",
        "#A5DFF7",
        "#F8E390",
        "#F09683",
        "#D6705F",
        "#C0504D",
      ];
      return colorList[name];
    },
    // 右侧柱状图
    rightBar9(element, data) {
      if (this.barChart9) {
        this.barChart9.dispose();
      }
      this.barChart9 = echarts.init(element);
      let option = {
        tooltip: {
          trigger: "axis",
          axisPointer: { type: "none" },
          // backgroundColor: "transparent", // 背景透明
          // borderWidth: 0, // 去掉边框
          // extraCssText: "box-shadow:none;padding:0;",
          // formatter: (params) => {
          //   return `
          //             <div class="tooltip-box">
          //                 <div class="tooltip-header"><div>${params[0].name}</div></div>
          //                 <div class="tooltip-item">
          //                     <span>达标数量</span>
          //                     <span class="text">${params[0].value}</span>
          //                 </div>
          //             </div>
          //         `;
          // },
        },
        grid: {
          top: "15%",
          right: "3%",
          left: "5%",
          bottom: "10%",
        },
        xAxis: [
          {
            type: "category",
            data: data.placeCount.map(ele => {
              return this.placeType1[+ele.label]
            }),
            axisLine: {
              lineStyle: {
                color: "#FFFFFF",
              },
            },
            axisLabel: {
              color: "#e2e9ff",
              textStyle: {
                fontSize: 12,
              },
              formatter: function (value) {
                return value.length > 3 ? value.substring(0, 3) + "..." : value;
              },
            },
            axisTick: {
              show: false,
            },
          },
        ],
        yAxis: [
          {
            axisLabel: {
              formatter: "{value}",
              color: "#e2e9ff",
            },
            axisTick: {
              show: false,
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: "rgba(0,186,255,.6)",
              },
            },
            splitLine: {
              lineStyle: {
                color: "rgba(255,255,255,0.12)",
              },
            },
          },
        ],
        series: [
          {
            type: "bar",
            data: data.placeCount.map(ele => ele.value),
            barWidth: "20px",
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: "#0EECE4", // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#058FE7", // 100% 处的颜色
                    },
                  ],
                  false
                ),
                //shadowColor: 'rgba(0,160,221,1)',
                //shadowBlur: 4,
              },
            },
            label: {
              normal: {
                show: false,
                lineHeight: 30,
                formatter: "{c}",
                position: "top",
                textStyle: {
                  color: "#00D6F9",
                  fontSize: 20,
                },
              },
            },
          },
        ],
      };
      this.barChart9.setOption(option);
      //
    },

    // 右侧 第二种模式 第一个饼图
    initPieChart(element, data) {
      if (this.pieChat) {
        this.pieChat.dispose();
      }
      this.pieChat = echarts.init(element);
      var m2R2Data = data.areaCount.map((ele, index) => {
        return {
          value: ele.value,
          legendname: ele.label,
          name: ele.label,
        }
      })
      let option = {
        tooltip: {
          trigger: "item",
          formatter: '{b}: {c} ({d}%)'
        },

        legend: {
          type: "scroll",
          orient: "horizontal",
          bottom: "0",
          icon: "circle",
          align: "left",
          textStyle: {
            color: "rgba(255, 255, 255, 1)",
          },
          height: 120,
        },
        series: [
          {
            name: "合格证地区开具数量占比",
            type: "pie",
            center: ["50%", "45%"],
            radius: ["55%", "85%"],
            clockwise: false, //饼图的扇区是否是顺时针排布
            avoidLabelOverlap: false,
            label: {
              formatter: '{b}: {d}%',
              normal: {
                show: false,
              },
            },
            labelLine: {
              show: false,
            },
            data: m2R2Data,
          },
        ],
      };

      this.pieChat.setOption(option);
    },
    // 左侧第二种顶部折线图
    initLine(element, data) {
      if (this.myChart) {
        this.myChart.dispose();
      }
      this.myChart = echarts.init(element);
      var xAxisData = [
        "08/01",
        "08/02",
        "08/03",
        "08/04",
        "08/05",
        "08/06",
        "08/07",
        "08/08",
        "08/09",
        "08/10",
        "08/11",
        "08/12",
      ];
      var legendData = ["投诉量", "解决量"];
      var title = "";
      var serieData = [];
      var metaDate = [
        [120, 140, 100, 120, 300, 230, 130, 170, 140, 120, 300, 230],
        [200, 120, 300, 200, 170, 300, 200, 180, 200, 190, 300, 200],
      ];
      for (var v = 0; v < legendData.length; v++) {
        var serie = {
          name: legendData[v],
          type: "line",
          symbolSize: 10,
          data: metaDate[v],
          symbol: "none",
          showSymbol: false,
        };
        serieData.push(serie);
      }
      var colors = ["#12FF75", "#2CD8DC"];
      var option = {
        backgroundColor: "#0f375f",
        title: {
          text: title,
          textAlign: "left",
          textStyle: { color: "#fff", fontSize: "16", fontWeight: "normal" },
        },
        legend: {
          show: true,
          left: "right",
          data: legendData,
          y: "5%",
          itemWidth: 18,
          itemHeight: 12,
          textStyle: { color: "#fff", fontSize: 14 },
        },
        color: colors,
        grid: {
          left: "2%",
          top: "12%",
          bottom: "5%",
          right: "5%",
          containLabel: true,
        },
        tooltip: {
          trigger: "axis",
          axisPointer: { type: "none" },
          backgroundColor: "transparent", // 背景透明
          borderWidth: 0, // 去掉边框
          extraCssText: "box-shadow:none;padding:0;",
          formatter: (params) => {
            return `
                        <div class="tooltip-box">
                            <div class="tooltip-header"><div>2025/08/20</div></div>
                            <div class="tooltip-item">
                                <div class="line"></div>
                                <span>新增</span>
                                <span class="text">102</span>
                            </div>
                            <div class="tooltip-item">
                                <div class="line"></div>
                                <span>累计</span>
                                <span class="text">102</span>
                            </div>
                        </div>
                    `;
          },
        },
        xAxis: [
          {
            type: "category",
            axisLine: { show: true, lineStyle: { color: "#6173A3" } },
            axisLabel: {
              interval: 0,
              textStyle: { color: "#E6F7FF", fontSize: 14 },
            },
            axisTick: { show: false },
            format: function (value) {
              console.log(value)
              return value;
            },
            data: xAxisData,
          },
        ],
        yAxis: [
          {
            axisTick: { show: false },
            splitLine: { show: false },
            axisLabel: { textStyle: { color: "#E6F7FF", fontSize: 14 } },
            axisLine: { show: true, lineStyle: { color: "#6173A3" } },
          },
        ],
        series: serieData,
      };
      this.myChart.setOption(option);
    },
    initLine2(element, data) {
      if (this.myChart1) {
        this.myChart1.dispose();
      }
      this.myChart1 = echarts.init(element);
      var option = {
        tooltip: {
          trigger: "axis",
          axisPointer: { type: "none" },
        },
        grid: {
          left: '2%',
          right: '4%',
          bottom: '4%',
          top: '8%',
          containLabel: true
        },
        legend: {
          data: ['累计量', '新增量'],
          right: 10,
          top: 0,
          textStyle: {
            color: "#fff"
          },
          itemWidth: 12,
          itemHeight: 10,
          // itemGap: 35
        },
        xAxis: {
          type: 'category',
          data: data.trendCount.map(ele => ele.date),
          axisLine: {

            lineStyle: {
              color: 'white'

            }
          },
          axisLabel: {
            // interval: 0,
            // rotate: 40,
            textStyle: {
              fontFamily: 'Microsoft YaHei',
              color: "white"
            }
          },
        },

        yAxis: {
          type: 'value',
          axisLine: {
            show: false,
            lineStyle: {
              color: 'white'
            }
          },
          splitLine: {
            show: false,
            lineStyle: {
              color: 'rgba(255,255,255,0.3)'
            }
          },
          axisLabel: {
            textStyle: {
              fontFamily: 'Microsoft YaHei',
              color: "white"
            }
          }
        },
        //  "dataZoom": [{
        //    "show": true,
        //    "height": 12,
        //    "xAxisIndex": [
        //      0
        //    ],
        //    bottom:'8%',
        //    "start": 10,
        //    "end": 90,
        //    handleIcon: 'path://M306.1,413c0,2.2-1.8,4-4,4h-59.8c-2.2,0-4-1.8-4-4V200.8c0-2.2,1.8-4,4-4h59.8c2.2,0,4,1.8,4,4V413z',
        //    handleSize: '110%',
        //    handleStyle:{
        //      color:"#d3dee5",

        //    },
        //    textStyle:{
        //      color:"#fff"},
        //    borderColor:"#90979c"
        //  }, {
        //    "type": "inside",
        //    "show": true,
        //    "height": 15,
        //    "start": 1,
        //    "end": 35
        //  }],
        series: [{
          name: '累计量',
          type: 'bar',
          barWidth: '15%',
          itemStyle: {
            normal: {
              color: "#12FF75",
            },
          },
          data: data.trendCount.map(ele => ele.historyCount),
        },
        {
          name: '新增量',
          type: 'bar',
          barWidth: '15%',
          itemStyle: {
            normal: {
              color: "#2CD8DC"
            }
          },
          data: data.trendCount.map(ele => ele.todayCount),
        }]
      };
      this.myChart1.setOption(option);
    },
    // initLine2(element, data) {
    // if (this.myChart1) {
    //   this.myChart1.dispose();
    // }
    // this.myChart1 = echarts.init(element);
    //   var xAxisData = data.trendCount.map(ele => ele.date);
    //   var legendData = ["累计量", "新增量"];
    //   var title = "";
    //   var serieData = [];
    //   var metaDate = [
    //     data.trendCount.map(ele => ele.historyCount),
    //     data.trendCount.map(ele => ele.todayCount),
    //   ];
    //   for (var v = 0; v < legendData.length; v++) {
    //     var serie = {
    //       name: legendData[v],
    //       type: "line",
    //       symbolSize: 10,
    //       data: metaDate[v],
    //       symbol: "none",
    //       showSymbol: false,
    //     };
    //     serieData.push(serie);
    //   }
    //   var colors = ["#12FF75", "#2CD8DC"];
    //   var option = {
    //     backgroundColor: "#0f375f",
    //     title: {
    //       text: title,
    //       textAlign: "left",
    //       textStyle: { color: "#fff", fontSize: "16", fontWeight: "normal" },
    //     },
    //     legend: {
    //       show: true,
    //       left: "right",
    //       data: legendData,
    //       y: "5%",
    //       itemWidth: 18,
    //       itemHeight: 12,
    //       textStyle: { color: "#fff", fontSize: 14 },
    //     },
    //     color: colors,
    //     grid: {
    //       left: "2%",
    //       top: "12%",
    //       bottom: "5%",
    //       right: "5%",
    //       containLabel: true,
    //     },
    // tooltip: {
    //   trigger: "axis",
    //   axisPointer: { type: "none" },
    //   backgroundColor: "transparent", // 背景透明
    //   borderWidth: 0, // 去掉边框
    //   extraCssText: "box-shadow:none;padding:0;",
    //   formatter: (params) => {
    //     return `
    //                 <div class="tooltip-box">
    //                     <div class="tooltip-header"><div>${params[0].axisValue}</div></div>
    //                     <div class="tooltip-item">
    //                         <div class="line"></div>
    //                         <span>新增</span>
    //                         <span class="text">${params[1].value}</span>
    //                     </div>
    //                     <div class="tooltip-item">
    //                         <div class="line"></div>
    //                         <span>累计</span>
    //                         <span class="text">${params[0].value}</span>
    //                     </div>
    //                 </div>
    //             `;
    //   },
    // },
    //     xAxis: [
    //       {
    //         type: "category",
    //         axisLine: { show: true, lineStyle: { color: "#6173A3" } },
    //         axisLabel: {
    //           interval: 0,
    //           textStyle: { color: "#E6F7FF", fontSize: 14 },
    //           formatter: function (value) {
    //           console.log(value,"value123")
    //           return value;
    //         },
    //         },
    //         axisTick: { show: false },

    //         data: xAxisData,
    //       },
    //     ],
    //     yAxis: [
    //       {
    //         axisTick: { show: false },
    //         splitLine: { show: false },
    //         axisLabel: { textStyle: { color: "#E6F7FF", fontSize: 14 } },
    //         axisLine: { show: true, lineStyle: { color: "#6173A3" } },
    //       },
    //     ],
    //     series: serieData,
    //   };
    //   this.myChart1.setOption(option);
    // },
    initBar(element, data) {
      if (this.barChart) {
        this.barChart.dispose();
      }
      this.barChart = echarts.init(element);
      let option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        grid: {
          top: "15%",
          right: "3%",
          left: "5%",
          bottom: "12%",
        },
        xAxis: [
          {
            type: "category",
            data: data.top10.map(ele => ele.label),
            axisLine: {
              lineStyle: {
                color: "#FFFFFF",
              },
            },
            axisLabel: {
              interval: 0,
              color: "#e2e9ff",
              textStyle: {

                fontSize: 12,
              },
              formatter: function (value) {
                return value.length > 3 ? value.substring(0, 3) + "..." : value;
              },
            },
            axisTick: {
              show: false,
            },
          },
        ],
        yAxis: [
          {
            axisLabel: {
              formatter: "{value}",
              color: "#e2e9ff",
            },
            axisTick: {
              show: false,
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: "rgba(0,186,255,.6)",
              },
            },
            splitLine: {
              lineStyle: {
                color: "rgba(255,255,255,0.12)",
              },
            },
          },
        ],
        series: [
          {
            type: "bar",
            data: data.top10.map(ele => ele.value),
            barWidth: "20px",
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: "#0EECE4", // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#058FE7", // 100% 处的颜色
                    },
                  ],
                  false
                ),
                //shadowColor: 'rgba(0,160,221,1)',
                //shadowBlur: 4,
              },
            },
            label: {
              normal: {
                show: false,
                lineHeight: 30,
                formatter: "{c}",
                position: "top",
                textStyle: {
                  color: "#00D6F9",
                  fontSize: 20,
                },
              },
            },
          },
        ],
      };
      this.barChart.setOption(option);
      //
    },
  },
};
